import React from 'react';

/**
 * Generates container styles for PostCard variants
 */
export function getContainerStyle(options: {
  roundedBottom?: boolean;
  compact?: boolean;
}): React.CSSProperties {
  const { roundedBottom, compact } = options;

  return {
    ...(roundedBottom && { borderRadius: '12px' }),
    ...(compact && {
      maxWidth: '400px',
      fontSize: '0.9em',
      margin: '0 auto'
    })
  };
}

/**
 * Generates wrapper styles for post content
 */
export function getWrapperStyle(options: {
  roundedBottom?: boolean;
}): React.CSSProperties {
  const { roundedBottom } = options;

  return {
    ...(roundedBottom && { borderRadius: '12px' }),
    background: 'white',
    minHeight: '200px'
  };
}
